import React, { PropTypes, Component } from 'react';
import PinPad from './pinPad';
import MobileNumberPad from '../../util/mobileNumberPad';
import { browserHistory } from 'react-router';

class Login extends Component {

  constructor(props) {
    super(props);

    this.state = { mobile: '', pin: '', clearInputs: false };
  }

  componentWillMount() {
    this.setState({ clearInputs: false });
  }

  mobileNumberComplete(mobile) {
    this.setState({ mobile: mobile });
  }

  pinComplete(pin) {
    this.setState({ pin: pin });
  }

  onForgotPassword() {
    this.props.actions.logout();
    browserHistory.push('/auth?mode=resetpassword');
  }

  handleChildUnmount() {
    this.setState({ clearInputs: false });
  }

  submit() {
    let loginModel = { username: this.state.mobile || this.props.username, password: this.state.pin };
    this.props.onSubmit(loginModel);
    this.setState({ clearInputs: true });
  }

  render() {
    const { handleSubmit, pristine, submitting, username } = this.props;
    let pinEnabled = this.state.mobile.length > 8 || (username && username.length) > 8;
    let confirmButtonEnabled = this.state.pin && (this.state.mobile.length > 8 || username.length > 8);
    return (
      <form>
        <h2 className="client-text text-center">Merchant Login</h2>
        <div className="row">
          <div className="col-md-12">
            <div className="card text-center p-l-5 p-r-5">

              {
                !username ?
                  < div >
                    <p><i className="login-icon fa fa-mobile" /> Mobile Number</p>
                    {!this.state.clearInputs && <MobileNumberPad strength={8} mobileNumberComplete={this.mobileNumberComplete.bind(this)} autoFocus={true} enabled={true} unmountMe={this.handleChildUnmount} />}
                  </div>
                  : null
              }
              <p className="m-t-15"><i className="login-icon fa fa-lock" /> PIN</p>
              {!this.state.clearInputs && <PinPad strength={4} pinComplete={this.pinComplete.bind(this)} autoFocus={true} enabled={pinEnabled} />}
              <div className="text-center m-t-20">
                <a href="#" onClick={this.onForgotPassword.bind(this)} className="page-login-forgot">Forgot your PIN?</a>
              </div>
            </div>
          </div>
        </div>
        <button disabled={!confirmButtonEnabled} className="btn btn-client btn-lg btn-block" onClick={this.submit.bind(this)} type="button">
          Login
        </button>
      </form >
    );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./app/auth/components/login.js